module.exports = __webpack_public_path__ + "img/workshop1-pc.d083bcac.png";